import { Card, Col, Row, Form, Button } from "react-bootstrap";
import { useState, useRef, useEffect } from "react";
import { RootState } from "redux/store";
import { useAppSelector, useAppDispatch } from "redux/hooks";
import { getDepartments } from "redux/slices/Departments";
import { Link, useNavigate, useParams } from "react-router-dom";
import { BulkEdit } from "./Popups/BulkEdit";
import { Stock } from "./Popups/Stock";
import { useToggle } from "hooks";
import { showToast } from "redux/slices/Toasts";
import { getSubDepartments } from "redux/slices/SubDepartment";
import { getStock, getStockTable } from "redux/slices/Stocks";
import { useDisplayError } from "helpers/Functions";
import { calculateMarkup, FormatDateToDMYH, displayFloatPrice, ParseAndValidateFloat, ToFixedNotRounded, calculateGP } from "helpers/data/dataHandling";
import { Modal, Spinner, Title, ProTable, FormInput, CustomFilter, ImportWizard, CustomColumns, CommonColumnProperties } from "components";
import { updatePriceGroupField, clearFilters, createPriceGroup, updatePriceGroup, cleanPriceGroups, getPriceGroupDetails, getPriceGroupsPrice, addSelectedRows, addDeselectedRows, applyPriceGroupsPrice, modifyPriceGroupsPrice, updatePriceGroupStock } from "redux/slices/PriceGroups";
import axios from "axios";
import { runBatchWorkers } from "components/WebWorkers/ZWebWorker";
import { getToken } from "helpers/api/authService";
import { PriceGroupImportWorkerData, PriceGroupImportWorkerResponseData } from "./priceGroupImportWorker";
import { DataResponse } from "models/common/responseObjects";

export function NewPriceGroupOld() {
    const form = useRef<any>(null);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { priceGroupId } = useParams();
    const displayError = useDisplayError();
    const [isValidated, setValidated] = useToggle();
    const priceGroupIdInt = parseInt(priceGroupId || "0");
    const [loading, setLoading] = useState<boolean>(false);
    const [originalName, setOriginalName] = useState<string>("");
    const [stockPopup, setStockPopup] = useState<boolean>(false);
    const [selectedStock, setSelectedStock] = useState<number>(0);
    const stocks = useAppSelector((state: RootState) => state.stocks);
    const [bulkEditPopup, setBulkEditPopup] = useState<boolean>(false);
    const [importPercentage, setImportPercentage] = useState<number>(0);
    const [isNewPriceGroup, setIsNewPriceGroup] = useState<boolean>(true);
    const [hasNameChanched, setHasNameChanched] = useState<boolean>(false);
    const priceGroup = useAppSelector((state: RootState) => state.priceGroups);
    const [showConfirmation, setShowConfirmation] = useState<boolean>(false);
    const [showImportWizard, setShowImportWizard] = useState<boolean>(false);
    const [loadingConfirmation, setLoadingConfirmation] = useState<boolean>(false);
    const storeGroupId = useAppSelector((state: RootState) => state.global.storeGroupId);
    const user = useAppSelector((state: RootState) => state.logedinUser);

    const columns = [
        {
            Header: "Name",
            accessor: "managedStockName",
            defaultCanSort: true,
            width: 200,
            // Cell: (row: any) => {
            //     return <a className="link" onClick={() => setSelectedStocks(row.row.original.managedStockId)}>{row.value}</a>;
            // },
        },
        {
            Header: "Cost",
            accessor: "managedStockCost",
            defaultCanSort: true,
            width: 70,
            Cell: (row: any) => displayFloatPrice(row.value),
        },
        {
            Header: "GP%",
            accessor: "markupCostBaseSellPpriceGP",
            // defaultCanSort: true,
            width: 70,
            Cell: (row: any) => {
                const sellPrice = row.cell.row.original.managedStockBaseSellPrice || 0;
                const costPrice = row.cell.row.original.managedStockCost || 0;
                const gstCode = row.cell.row.original.managedStockGstCode || 'Y';
                return <span>{calculateGP(sellPrice, costPrice, gstCode)}</span>;
            }
        },
        {
            Header: "Base Sell Price",
            accessor: "managedStockBaseSellPrice",
            defaultCanSort: true,
            width: 100,
            Cell: (row: any) => displayFloatPrice(row.value),
        },
        {
            Header: "Current GP%",
            accessor: "markupBaseSellPriceCurrentSellPriceGP",
            // defaultCanSort: true,
            width: 70,
            Cell: (row: any) => {
                const sellPrice = row.cell.row.original.price || 0;
                const costPrice = row.cell.row.original.managedStockCost || 0;
                const gstCode = row.cell.row.original.managedStockGstCode || 'Y';
                return <span>{calculateGP(sellPrice, costPrice, gstCode)}</span>;

            }
        },
        {
            Header: "Current Sell Price",
            accessor: "price",
            defaultCanSort: true,
            width: 100,
            Cell: (row: any) => displayFloatPrice(row.value),
        },
        {
            Header: "New GP%",
            accessor: "newGp",
            // defaultCanSort: true,
            width: 80,
            Cell: (row: any) => {
                const sellPrice = row.cell.row.original.newPrice || 0;
                const costPrice = row.cell.row.original.managedStockCost || 0;
                const gstCode = row.cell.row.original.managedStockGstCode || 'Y';
                return <span>{calculateGP(sellPrice, costPrice, gstCode)}</span>;
            }
        },
        {
            Header: "New Sell Price",
            accessor: "newPrice",
            defaultCanSort: true,
            width: 100,
            Cell: (row: any) => <NewPriceField row={row} />,
        },
        {
            Header: "Last Applied",
            accessor: "applied",
            defaultCanSort: true,
            width: 200,
            Cell: (row: any) => {
                return <span>{FormatDateToDMYH(row.value)}</span>;
            }
        }
    ];

    const NewPriceField = ({ row }: any) => {
        const [newPriceFieldValue, setNewPriceFieldValue] = useState<string | undefined>(row.value?.toString() ?? undefined);        
        const [oldPriceValue, setOldPriceValue] = useState<string | ''>('');
        const [loadingValue, setLoadingValue] = useState(false);
        const [isEditing, setIsEditing] = useState(false);
        const ref: any = useRef(null);
        async function updateNewPriceFieldValue(newPriceField: number | null) {
            setIsEditing(false);
            setLoadingValue(true);
            const trimmedPriceString = newPriceField?.formatAsPrice();
            const newPrice = trimmedPriceString !== undefined ? parseFloat(trimmedPriceString) : null;
            if (newPriceField !== row.value) {
                await dispatch(modifyPriceGroupsPrice([{
                    ...row.cell.row.original,
                    newPrice: newPrice,
                }])).then(async (res) => {
                    if (res.data) {
                        setNewPriceFieldValue(trimmedPriceString);
                        const index = priceGroup.stock.findIndex((x: any) => x.id === row.cell.row.original.id);
                        dispatch(updatePriceGroupStock({ index: index, key: "newPrice", value: newPrice }));
                    }
                }).catch((error) => {
                    displayError(error);
                });
            }
            setLoadingValue(false);
            console.log("is value? ");
            console.log(newPriceFieldValue ? "Yes" : "No");
        }

        const refCallback = (node: any) => {
            ref.current = node;
        }

        useEffect(() => {
            if (ref.current) ref.current.focus();
        }, [ref.current, refCallback]);

        async function saveValue(value: string) {
            //Handle clearing
            if (oldPriceValue !== value && value === '') {
                await updateNewPriceFieldValue(null);
                return;
            }

            let parsedValue = parseFloat(value);
            if (!Number.isNaN(parsedValue) && parsedValue >= 0) {
                await updateNewPriceFieldValue(parsedValue);
            }
            setIsEditing(false);
        }

        const sanitizePriceInput = (inputValue: string): string => {
            const match = inputValue.match(new RegExp(/^(\d*.{0,1}\d*)$/));
            return match ? match[0] : "";
        };

        function setPriceField(e: any) {
            console.log(e.target);
            console.log("Value as number: " + e.target.valueAsNumber);
            
            const newInputValue = e.target.value.trim();
            const sanitizedValue = sanitizePriceInput(newInputValue);

            if (newInputValue === "" || parseFloat(sanitizedValue) === 0) {
                setNewPriceFieldValue(undefined);
            } else if (sanitizedValue !== "") {
                setNewPriceFieldValue(sanitizedValue);
            }
        }

        const handleKeyDown = async (e: any) => {
            if (e.key === "Enter") {
                let parsedValue = parseFloat(newPriceFieldValue ?? "");
                if (!Number.isNaN(parsedValue) && parsedValue >= 0) {
                    await updateNewPriceFieldValue(parsedValue);
                }
            } else if (!/([\d.])|(Backspace|Tab|Delete|ArrowLeft|ArrowRight)/.test(e.key)) {
                e.preventDefault();
            }
        }
        return (
            <>{loadingValue ?
                <span><Spinner className="spinner-border-sm me-1" tag="span" color="primary" />Saving... </span>
                :
                <>{user.permissions.priceGroups.canUpdate && isEditing ?
                    <div className={"actions"}>
                        <FormInput
                            refCallback={refCallback}
                            min={0}
                            step={0.01}
                            required
                            type="text"
                            prepend="$"
                            containerClass={"m-0"}
                            value={newPriceFieldValue ?? ''}
                            onKeyDown={handleKeyDown}
                            name="price-level-new-sell-price"
                            onChange={(e) => setPriceField(e)}
                            onBlur={async (e) => {
                                console.log("onBlur = " + newPriceFieldValue);
                                const parsedVal = parseFloat(newPriceFieldValue ?? "");
                                console.log("parsedVal = " + parsedVal);
                                if (newPriceFieldValue === undefined) {
                                    await updateNewPriceFieldValue(null);
                                } else if (!isNaN(parsedVal)) {
                                    const formattedVal = parsedVal.formatAsPrice();
                                    console.log("formattedVal = " + formattedVal);
                                    setNewPriceFieldValue(formattedVal);
                                    await updateNewPriceFieldValue(parseFloat(formattedVal));
                                }
                            }}
                        />
                    </div>
                    :
                    <>{user.permissions.priceGroups.canUpdate ?
                        <div className={newPriceFieldValue ? "actions" : "no-actions"}>
                            <a className="link" onClick={() => {
                                setIsEditing(true);
                                setOldPriceValue(newPriceFieldValue ?? '');
                            }}>{newPriceFieldValue ? displayFloatPrice(newPriceFieldValue) : "$__.__"}<i className="ms-1 text-primary mdi mdi-pencil"></i></a>
                        </div>
                        :
                        <div>{displayFloatPrice(newPriceFieldValue ?? "")}</div>
                    }
                    </>
                }</>
            }</>
        );
    }

    useEffect(() => {
        handleInitPriceGroup();
    }, []);

    useEffect(() => {
        handleInitPriceGroup();
    }, [priceGroupIdInt]);

    useEffect(() => {
        if (priceGroup.departmentIdFilter !== 0) {
            dispatch(getSubDepartments(priceGroup.departmentIdFilter));
        } else {
            handleUpdate("subdepartmentIdFilter", 0);
        }
    }, [priceGroup.departmentIdFilter]);

    function handleInitPriceGroup() {
        dispatch(getDepartments());
        dispatch(clearFilters());
        if (priceGroupIdInt) {
            setIsNewPriceGroup(true);
            dispatch(getPriceGroupDetails(priceGroupIdInt)).then((res) => {
                res.data[0].name && setOriginalName(res.data[0].name);
            });
            dispatch(getPriceGroupsPrice({ priceGroupIds: [priceGroupIdInt] }));
        } else {
            setIsNewPriceGroup(false);
            dispatch(cleanPriceGroups());
        }
    }

    function setSelectedStocks(managedStockId: number) {
        setSelectedStock(managedStockId);
        setStockPopup(true);
    }

    function createNewPriceGroup() {
        dispatch(createPriceGroup({
            name: priceGroup.name,
            id: 0,
        })).then((res) => {
            // await handlePriceGroupUpdate(res);
            setLoading(false);
            res.data[0] > 0 && navigate(`/app/price-group/${res.data[0]}`);
        });
    }

    async function handleUpdatePriceGroup() {
        const res = await dispatch(updatePriceGroup({
            id: priceGroup.id,
            name: priceGroup.name,
        }));
        return res;
    }

    async function handleSave() {
        setLoading(true);
        // @ts-ignore
        if (form.current.checkValidity() === true) {
            if (!isNewPriceGroup) {
                createNewPriceGroup();
            } else {
                const res = await handleUpdatePriceGroup();
                handlePriceGroupUpdate(res);
            }
        }
    }

    async function handleSubmit() {
        setLoading(true);
        if (form.current.checkValidity() === true) {
            if (!isNewPriceGroup) {
                createNewPriceGroup();
            } else {
                setLoadingConfirmation(true);
                const res = await handleUpdatePriceGroup();
                await dispatch(applyPriceGroupsPrice({
                    filter: {
                        priceGroupIds: [priceGroup.id],
                        // managedStockKeyword: priceGroup.keyword,
                        ...(priceGroup.keyword !== "") && { managedStockKeyword: priceGroup.keyword },
                        managedStockIds: priceGroup.selectedRows.length > 0 ? priceGroup.selectedRows.map((item: any) => item.map((item: any) => item.id)).flat() : [],
                        ...priceGroup.departmentIdFilter !== 0 && { managedStockDepartmentIds: [priceGroup.departmentIdFilter] },
                        ...priceGroup.subdepartmentIdFilter !== 0 && { managedStockSubdepartmentIds: [priceGroup.subdepartmentIdFilter] },
                        offset: stocks.pageIndex * stocks.pageSize,
                        limit: stocks.pageSize,
                    },
                    sync: true,
                    applyEmptyValues: false,
                }));
                await handlePriceGroupUpdate(res);
            }
        }
    }

    async function handlePriceGroupUpdate(res: DataResponse<any>) {
        if (res.data) {
            dispatch(cleanPriceGroups());
            dispatch(getPriceGroupsPrice({ priceGroupIds: [priceGroupIdInt] }));
            dispatch(getPriceGroupDetails(priceGroupIdInt)).then((res) => {
                res.data[0].name && setOriginalName(res.data[0].name);
            });
            setShowConfirmation(false);
        } else {
            dispatch(showToast({ value: ["An unknown error occured"] }));
        }
        setLoading(false);
        setHasNameChanched(false);
    }

    function TopbarChildComponent() {
        let selectedRowsCount = 0;
        priceGroup.selectedRows.map((item: any) => item.forEach(() => selectedRowsCount++));
        return (
            <> {selectedRowsCount > 1 &&
                <Button disabled variant="light" className="me-1">{selectedRowsCount} Selected</Button>
            } </>
        );
    }

    function onSearchClick(keyword: string) {
        handleUpdate("pageIndex", 0);
        handleUpdate("keyword", keyword);
        dispatch(getPriceGroupsPrice({
            managedStockKeyword: keyword,
            ...getStockFilterOptions(),
            priceGroupIds: [priceGroupIdInt],
            ...priceGroup.departmentIdFilter !== 0 && { managedStockDepartmentIds: [priceGroup.departmentIdFilter] },
            ...priceGroup.subdepartmentIdFilter !== 0 && { managedStockSubdepartmentIds: [priceGroup.subdepartmentIdFilter] },
            limit: 0,
        }));
    }

    function getStockFilterOptions() {
        let payload: any = {};
        if (priceGroup.departmentIdFilter !== 0) payload.managedStockDepartmentIds = [priceGroup.departmentIdFilter];
        if (priceGroup.subdepartmentIdFilter !== 0) payload.managedStockSubdepartmentIds = [priceGroup.subdepartmentIdFilter];
        if (priceGroup.supplierIdFilter !== 0) payload.managedStockSupplierIds = [priceGroup.supplierIdFilter];
        if (priceGroup.stockGroupIdFilter !== 0) payload.managedStockStockGroupIds = [priceGroup.stockGroupIdFilter];
        if (priceGroup.activeFilter !== 0) payload.managedStockActive = priceGroup.activeFilter === 1 ? true : false;
        if (priceGroup.ethicalFilter !== 0) payload.managedStockEthical = priceGroup.ethicalFilter === 1 ? true : false;
        if (priceGroup.scheduleFilter !== "0") payload.managedStockSchedule = priceGroup.scheduleFilter;
        if (priceGroup.pbsFilter !== 0) payload.managedStockPbs = priceGroup.pbsFilter === 1 ? true : false;
        return payload;
    }

    function updateTableRows(dataTableState: any) {
        handleUpdate("pageIndex", dataTableState.pageIndex);
        handleUpdate("pageSize", dataTableState.pageSize);
        dispatch(getPriceGroupsPrice({
            ...getStockFilterOptions(),
            managedStockKeyword: priceGroup.keyword,
            priceGroupIds: [priceGroupIdInt],
            offset: dataTableState.pageIndex * dataTableState.pageSize,
            limit: dataTableState.pageSize,addSelectedRows
        }));
    }

    function selectedRowsUpdate(rows: any, index: any) {
        dispatch(addSelectedRows({ rows: rows, index: index }));
    }

    function deselectedRowsUpdate(rows: any, index: any) {
        dispatch(addDeselectedRows({ rows: rows, index: index }));
    }

    function handleUpdate(key: string, value: any) {
        dispatch(updatePriceGroupField({ key: key, value: value }));
    }

    function handleSubmitConfirmation() {
        setLoading(false);
        setLoadingConfirmation(false);

        if (isNewPriceGroup) {
            setShowConfirmation(true);
        } else {
            handleSubmit();
        }
    }

    function countPriceGroupSelectedRows() {
        let selectedRowsCount = 0;
        priceGroup.selectedRows.map((item: any) => item.forEach(() => selectedRowsCount++));
        return selectedRowsCount > 0 ? selectedRowsCount : priceGroup.totalRows;
    }

    const importWizardExtraMatches: CustomColumns[] = [
        {
            title: "New Sell Price",
            key: "newSellPrice",
            required: true,
            display: true,
            autoMatch: ["sell", "sell price", "retail"],
            validation: (value: any) => {
                let res = ParseAndValidateFloat(value, 0)
                if (res.output) {
                    return { valid: true, error: "", newValue: ToFixedNotRounded(res.value, 2) }
                } else {
                    return { valid: false, error: "Sell price invalid" }
                }
            }
        },
    ];

    const terminateWorkersRef = useRef<Function>();

    async function BulkUpdateStock(rows: CommonColumnProperties[]) {
        const webWorkerData: PriceGroupImportWorkerData = {
			data: rows,
            priceGroupId: priceGroupIdInt,
		}

		const errors: Map<string, string> = new Map<string, string>();

		const { runWorkers, terminateWorkers } = runBatchWorkers<PriceGroupImportWorkerData, CommonColumnProperties, PriceGroupImportWorkerResponseData>({
            workerData: webWorkerData, 
            createWorker: () => new Worker(new URL('./priceGroupImportWorker.ts', import.meta.url)), 
            onWorkerResponse: (async (event, responseContext, httpErrors, reject) => {
                if (!responseContext.response.data) {
                    if (httpErrors) {
                        const combinedError = httpErrors.join(", ");
                        // Now using this combined error, construct a { stockName, error } object for each stock and push it onto the errors array
                        responseContext.originalBatchData.forEach((r: any) => {
                            const errorEntry = errors.get(r.name);
                            errors.set(r.name ?? "", errorEntry ? errorEntry + ", " + combinedError : combinedError);
                        });
                    }
                } else {
                    // Add to errors for each item in response.data.nonMatchingStocks in the structure { stockName: s, errorMsg: "Could not find a match for this stock" }
                    responseContext.response.data.nonMatchingStocks.forEach(nms => {
                        const errorEntry = errors.get(nms.name);
                        errors.set(nms.name ?? "", errorEntry ? errorEntry + ", " + "Could not match stock" : "Could not match stock");
                    })
                    
                    // Update the stocks
                    await dispatch(modifyPriceGroupsPrice(responseContext.response.data.updatedStocks));
                }

				setImportPercentage((prev) => Math.min(100, prev + ((1 / responseContext.numBatches) * 100)));
            }), 
            onWorkersFinished: async (_) => {
                dispatch(getPriceGroupsPrice({ priceGroupIds: [priceGroupIdInt] }));
                setImportPercentage(0); //Reset the import percentage
            }, 
            onWorkerError: (error, unprocessedData) => {
                unprocessedData.forEach(data => {
                    const errorEntry = errors.get(data.name ?? "");
                    const errorMessage = error.message ?? "Unknown error occurred";
                    errors.set(data.name ?? "", errorEntry ? errorEntry + ", " + errorMessage : errorMessage);
                })
            }
        });

        terminateWorkersRef.current = terminateWorkers;

        await runWorkers;

		const returnErrors: { stockName: string, error: string }[] = [];

		errors.forEach((value: string, key: string) => {
			returnErrors.push({
				stockName: key,
				error: value,
			})
		});

		return [...returnErrors];
    }

    function importWizardValidateForms(rows: CommonColumnProperties[]): CommonColumnProperties[] {
        let temp: CommonColumnProperties[] = [...rows];
        rows.forEach(row => {
            if (row.newSellPrice !== undefined) {
                const newSellPrice = row.newSellPrice;
                row.newSellPrice = parseFloat(newSellPrice);
            }
        });
        return temp;
    }

    return (
        <>
            <Title pageTitle={isNewPriceGroup ? "Update Price Group" : "New Price Group"} crumbs={[{ name: "Price Groups", path: "/app/price-groups" }]} />
            <Row>
                <Col xs={12}>
                    <Card>
                        <Card.Body>
                            <Form onSubmit={(e) => { 
                                e.preventDefault();
                                handleSubmitConfirmation();
                            }} validated={isValidated} ref={form}>
                                <Row>
                                    <h4 className="mt-2">Price Group Details</h4>
                                </Row>
                                <Row className="price-group-name">
                                    <Col xs={3}>
                                        <FormInput
                                            required
                                            label="Name"
                                            type="text"
                                            name="price-level-name"
                                            placeholder="Enter Name"
                                            containerClass={"mb-2"}
                                            value={priceGroup.name}
                                            onChange={(e) => handleUpdate("name", e.target.value)}
                                        />
                                    </Col>
                                    <Col xs={6} className="d-flex align-items-end">
                                        {priceGroup.name !== "" && originalName !== priceGroup.name && isNewPriceGroup &&
                                            <Button variant="primary" className="ms-1 extra-button btn cta-button" onClick={handleSave}>Save</Button>
                                        }
                                    </Col>
                                </Row>
                                {isNewPriceGroup && <>
                                    <Row className="mb-1 ps-1 pe-1">
                                        <div className="page-container">
                                            <BulkEdit show={bulkEditPopup} handleClose={() => setBulkEditPopup(false)} />
                                            <Stock show={stockPopup} selectedStock={selectedStock} handleClose={() => setStockPopup(false)} />
                                            <Modal
                                                title="Confirm"
                                                show={showConfirmation}
                                                buttonType="primary"
                                                disableButtons={loadingConfirmation}
                                                buttonText={loadingConfirmation ? "Applying..." : "Continue"}
                                                handleSubmit={handleSubmit}
                                                handleClose={() => setShowConfirmation(false)}
                                                description={
                                                    <>
                                                        <p>You are about to apply {countPriceGroupSelectedRows()} new sell price(s) and sync them to their assigned store(s).</p>
                                                        <p>Are you sure you want to continue?</p>
                                                    </>
                                                }
                                            />
                                            <ImportWizard
                                                title="Price Group Prices"
                                                display={showImportWizard}
                                                handleClose={() => { 
                                                    if (terminateWorkersRef.current) terminateWorkersRef.current();
                                                    setShowImportWizard(false); 
                                                }}
                                                importAsync={(i) => BulkUpdateStock(i)}
                                                customColumns={importWizardExtraMatches}
                                                validateTable={(rows) => importWizardValidateForms(rows)}
                                                matchAgainst="Stocks"
                                                finish={() => setShowImportWizard(false)}
                                                importPercentage={importPercentage}
                                            />

                                            <ProTable
                                                data={priceGroup}
                                                pageSize={100}
                                                table={priceGroup.stock}
                                                isSortable={true}
                                                pagination={true}
                                                columns={columns}
                                                loading={priceGroup.loadingStocks}
                                                updateTableRows={updateTableRows}
                                                // Search Props
                                                isSearchable={true}
                                                onSearchClick={onSearchClick}
                                                // Toolbar Props
                                                singleImport={user.permissions.priceGroups.canImport ? () => setShowImportWizard(true) : undefined}
                                                reloadTableRows={() => dispatch(getPriceGroupsPrice({ priceGroupIds: [priceGroupIdInt] }))}
                                                // Select Props
                                                isSelectable={true}
                                                selectedRows={priceGroup.selectedRows}
                                                deselectedRows={priceGroup.deselectedRows}
                                                selectedRowsUpdate={selectedRowsUpdate}
                                                deselectedRowsUpdate={deselectedRowsUpdate}
                                                // Extra Components Props
                                                topbarChild={<TopbarChildComponent />}
                                                filterComponent={
                                                    <CustomFilter
                                                        data={priceGroup}
                                                        handleChange={handleUpdate}
                                                        clearFilters={() => dispatch(clearFilters())}
                                                        applyFilters={() => onSearchClick(priceGroup.keyword)} />
                                                }
                                            />
                                        </div>
                                    </Row>
                                </>}
                                <Row className="mt-3 mb-2">
                                    <Col sm={6}>
                                        <Link to="/app/price-groups" className="btn text-muted d-none d-sm-inline-block btn-link fw-semibold" onClick={() => dispatch(cleanPriceGroups())}>
                                            <i className="mdi mdi-arrow-left"></i> Back to All Price Groups{" "}
                                        </Link>
                                    </Col>
                                    <Col sm={6} className="d-flex flex-row-reverse">
                                        {!isNewPriceGroup ?
                                            <Button variant="primary" className="ms-1 btn cta-button" onClick={handleSave} disabled={!user.permissions.priceGroups.canCreate}>
                                                {loading && <Spinner className="spinner-border-sm me-1" tag="span" color="white" />}
                                                {loading ? <>Saving...</> : <>Save</>}
                                            </Button>
                                            :
                                            <Button variant="primary" className="btn cta-button" disabled={loading || !user.permissions.priceGroups.canUpdate} onClick={handleSubmitConfirmation}>
                                                {loading && <Spinner className="spinner-border-sm me-1" tag="span" color="white" />}
                                                {loading ? <>Applying...</> : <>Apply & Sync</>}
                                            </Button>
                                        }
                                    </Col>
                                </Row>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    );
}